module.exports = __webpack_public_path__ + "static/adam-doodle-926c28a28032e4a89ca2625e46d4ef58.svg";